/** @jsxImportSource @emotion/react */
import { Box, Skeleton, Typography, useTheme } from '@mui/material'
import { thumbnailListItem } from './RiskStoryCard.styles'
import { riskPageContainer } from '@app/routes/RiskPage/RiskPage.styles'
import { storyListContainer } from './RiskStoryList.style'
import { sideDrawerContentParent } from '@app/components/Molecules/RiskSideDrawerContent/RiskSideDrawerContent.styles'
import { SideDrawerHeader } from '@app/components/Molecules/RiskSideDrawerContent/components/SideDrawerHeader/SideDrawerHeader'

interface RiskStoriesListLoadingProps {
  isError?: boolean
  numberOfItems?: number
}

const RiskStoriesListLoading = ({
  isError = false,
  numberOfItems = 3,
}: RiskStoriesListLoadingProps) => {
  const theme = useTheme()

  if (isError) {
    return (
      <Box css={sideDrawerContentParent()}>
        <SideDrawerHeader
          title="RISK STORIES"
          subtitle={'error loading stories'}
          iconName="s3://openbook.svg"
        />
        <Box>
          <Typography color="error" variant="body1" sx={{ padding: theme.spacing(2) }}>
            There was an error loading the risk stories. Please try again later.
          </Typography>
        </Box>
      </Box>
    )
  }

  return (
    <Box css={riskPageContainer}>
      <Box css={storyListContainer(theme)}>
        {Array.from({ length: numberOfItems }).map((_, index) => (
          <Box key={index} css={thumbnailListItem(theme)}>
            <Box className="thumbnail">
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                sx={{
                  borderRadius: theme.spacing(1),
                  bgcolor: theme.palette.grey[200],
                }}
              />
            </Box>
            <Box className="label">
              <Skeleton variant="text" />
              <Box className="description">
                <Skeleton variant="text" />
              </Box>
              <Box className="chapterCount">
                <Skeleton variant="text" />
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
export default RiskStoriesListLoading
